import MessageFormat from 'messageformat'

export default class CustomFormatter {
  constructor(options = {}) {
    this._locale = options.locale || 'fr-FR'
    this._formatter = new MessageFormat(this._locale)
    this._formatter.setIntlSupport && this._formatter.setIntlSupport(true)
    this._caches = Object.create(null)
  }

  interpolate(message, values) {
    let fn = this._caches[message]
    if (!fn) {
      fn = this._formatter.compile(message, this._locale)
      this._caches[message] = fn
    }
    return [fn(values)]
  }
}

export const dateTimeFormats = {
  'fr-FR': {
    short: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    },
    shortAll: {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    },
    year: {
      year: 'numeric'
    },
    advices: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    },
    month: {
      month: 'long'
    },
    monthYear: {
      year: 'numeric',
      month: 'long'
    },
    monthYearShort: {
      year: 'numeric',
      month: '2-digit'
    },
    day: {
      day: '2-digit',
      month: 'long'
    },
    time: {
      hour: '2-digit',
      minute: '2-digit'
    },
    timeShort: {
      minute: 'numeric',
      second: '2-digit'
    }
  },
  'en-US': {
    englishShort: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }
  }
}

export const numberFormats = {
  'fr-FR': {
    currency: {
      style: 'currency',
      currency: 'EUR'
    },
    conciseCurrency: {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    percent: {
      style: 'percent',
      maximumFractionDigits: 2
    },
    percentThreeDigits: {
      style: 'percent',
      maximumFractionDigits: 3
    },
    percentFourDigits: {
      style: 'percent',
      maximumFractionDigits: 4
    },
    percentFiveDigits: {
      style: 'percent',
      maximumFractionDigits: 5
    },
    parts: {
      style: 'decimal',
      maximumFractionDigits: 4
    },
    notation: {
      style: 'decimal',
      maximumFractionDigits: 2
    },
    integer: {
      style: 'decimal',
      maximumFractionDigits: 0
    }
  }
}
